import { jsxs as x, jsx as s } from "react/jsx-runtime";
import { styled as t, createGlobalStyle as k, css as n } from "styled-components";
import "react";
const g = t.a`
  --link-color: ${({ theme: e }) => e.colors.blue50};
  --link-hover-color: ${({ theme: e }) => e.colors.blue40};

  display: inline-flex;
  font-size: 16px;
  line-height: 24px;
  border: none;
  font-weight: ${({ $bold: e }) => e ? 700 : 400};
  outline: none;
  text-decoration: none;
  color: var(--link-color);
  white-space: nowrap;
  gap: 8px;
  align-items: center;

  [data-name='hn-icon'] {
    fill: var(--link-color);
  }

  &:focus-visible {
    color: var(--link-hover-color);
    outline: auto;

    [data-name='hn-icon'] {
      fill: var(--link-hover-color);
    }
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--link-hover-color);

      [data-name='hn-icon'] {
        fill: var(--link-hover-color);
      }
    }
  }
`, u = ({
  href: e,
  target: o = "_self",
  onClick: l,
  children: i,
  bold: a = !1,
  Icon: c,
  className: r,
  ...m
}) => /* @__PURE__ */ x(
  g,
  {
    onClick: l,
    href: e,
    target: o,
    $bold: a,
    className: r,
    ...m,
    children: [
      i,
      c ? /* @__PURE__ */ s(c, {}) : void 0
    ]
  }
), w = t(u)`
  --link-color: ${({ theme: e }) => e.colors.blue50};
  --link-hover-color: ${({ theme: e }) => e.colors.blue40};
`, G = ({ ...e }) => /* @__PURE__ */ s(w, { ...e }), y = t(u)`
  --link-color: ${({ theme: e }) => e.colors.darkBlue30};
  --link-hover-color: ${({ theme: e }) => e.colors.darkBlue10};
`, M = ({ ...e }) => /* @__PURE__ */ s(y, { ...e }), $ = t(u)`
  --link-color: ${({ theme: e }) => e.colors.purple30};
  --link-hover-color: ${({ theme: e }) => e.colors.purple10};
`, R = ({ ...e }) => /* @__PURE__ */ s($, { ...e }), v = (e, o) => o in e.colors, z = {
  phoneSm: "320px"
}, C = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
k`
  ${C}

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  body {
    min-width: ${z.phoneSm};
  }

  body,
  button,
  input {
    font-family: ${({ theme: e }) => e.fontFamily};
    color: ${({ theme: e }) => e.colors.black10};
  }
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  input,
  hr,
  button,
  section,
  menu {
    margin: 0;
    padding: 0;
  }
  div,
  section,
  input,
  button {
    box-sizing: border-box;
  }
  input {
    outline: none;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition: background-color 100s ease-in-out 0s;
  }
  button {
    border: none;
  }
`;
const L = t.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 16px;
  font-size: 13px;
`;
t.div`
  display: flex;
`;
t.p`
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
`;
t.div`
  display: flex;
`;
t(L)`
  margin-bottom: 0;
  margin-top: 8px;
  min-height: 1em;
  font-size: 16px;
`;
t.div`
  display: flex;
  align-items: center;
`;
t.p`
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.1px;
  color: ${({ theme: e }) => e.colors.red50};
`;
n`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  ${({ theme: { down: e } }) => e("tablet")} {
    font-size: 14px;
  }
`;
const b = "0px 1px 8px rgba(0, 0, 0, 0.17)", f = "0px 4px 20px rgba(0, 0, 0, 0.07)", h = "0px 4px 28px rgba(0, 0, 0, 0.14)";
n`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${b});
`;
n`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${f});
`;
n`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${h});
`;
n`
  box-shadow: ${b};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
n`
  box-shadow: ${f};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
n`
  box-shadow: ${h};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
const F = n`
  ${({ color: e, theme: o, disabled: l }) => {
  let i;
  return l ? i = typeof l == "string" ? o.colors[l] ?? l : o.colors.black80 : e && v(o, e) ? i = o.colors[e] : i = e || o.colors.icon, n`
      fill: ${i};
      stroke: ${i};
    `;
}};

  g {
    fill: inherit;
    stroke: inherit;
  }

  *:not([stroke]) {
    &[fill='none'] {
      stroke-width: 0;
    }
  }

  *[stroke*='#'],
  *[STROKE*='#'] {
    stroke: inherit;
    fill: none;
  }

  *[fill-rule],
  *[FILL-RULE],
  *[fill*='#'],
  *[FILL*='#'] {
    stroke: none;
  }

  *[fill-rule],
  *[FILL-RULE],
  *[fill*='#']:not([fill='#FFF']),
  *[FILL*='#']:not([FILL='#FFF']) {
    fill: inherit;
  }
`, p = 24, B = (e) => {
  const o = e.match(/\d+(\.\d+)?/);
  return o ? parseFloat(o[0]) : p;
}, I = t.svg`
  display: inline-block;
  flex: 0 0 auto;
  ${({ size: e = p, theme: o, viewBox: l }) => {
  const [, , i, a] = (l || `0 0 ${p} ${p}`).split(
    " "
  ), c = +i / +a, r = B(o.icons.size[e] || `${e}px`);
  return i < a ? `
      width: ${r}px;
      height: ${r / c}px;
    ` : a < i ? `
      width: ${r * c}px;
      height: ${r}px;
    ` : `
      width: ${r}px;
      height: ${r}px;
    `;
}}
  ${({ $hasOwnColorPattern: e }) => e ? void 0 : F};
`, H = ({ a11yTitle: e, ...o }) => /* @__PURE__ */ s(I, { ...o, name: e, "data-name": "hn-icon" }), d = (e) => /* @__PURE__ */ s(H, { viewBox: "0 0 24 24", a11yTitle: "GoLink", ...e, children: /* @__PURE__ */ s(
  "path",
  {
    d: "M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 12.45 20.55 12 20 12C19.45 12 19 12.45 19 13V18C19 18.55 18.55 19 18 19ZM14 4C14 4.55 14.45 5 15 5H17.59L8.46 14.13C8.07 14.52 8.07 15.15 8.46 15.54C8.85 15.93 9.48 15.93 9.87 15.54L19 6.41V9C19 9.55 19.45 10 20 10C20.55 10 21 9.55 21 9V3H15C14.45 3 14 3.45 14 4Z",
    fill: "#0091DF"
  }
) });
d.displayName = "GoLink";
const S = t(u)`
  --link-color: ${({ theme: e }) => e.colors.blue50};
  --link-hover-color: ${({ theme: e }) => e.colors.blue40};
`, D = ({
  ...e
}) => /* @__PURE__ */ s(S, { ...e, target: "_blank", Icon: d });
export {
  D as BlueExternalLink,
  G as BlueLink,
  M as DarkBlueLink,
  R as PurpleLink
};
